function cov_12oa86xcfl() {
  var path = "/app/src/components/snippet-default/index.ts";
  var hash = "e74ba4445b0ba0716b2fe853d4d234049ff40818";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/snippet-default/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e74ba4445b0ba0716b2fe853d4d234049ff40818"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_12oa86xcfl = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_12oa86xcfl();
export { SnippetDefault } from './snippet-default';